import { CreateTemplate, Warning, Alert } from "../icons";
import { localStorageHelper } from "../utils";
import { getUserRole } from "../utils/genericUtils";

export const dragAndDrop = {
  maxUploads: 5,
};

export const catalogListType = {
  0: "all",
  1: "trending",
  2: "is_gen_ai_template",
};

export const userCatalogListType = {
  0: "all",
  1: "is_gen_ai_template",
};

export const usageTabs = {
  0: "summary",
  1: "usageReports",
};

export const userCatalogProviderType = {
  AWS: 0,
  AZURE: 1,
  GCP: 2,
};

export const PROVIDER_OPTIONS = [
  { label: "AWS", value: "aws", providerType: userCatalogProviderType.AWS },
  { label: "Azure", value: "azure", providerType: userCatalogProviderType.AZURE },
];

export const addBefore = "makemylabs.in/";
export const backdrop = {
  delete: "delete",
  clone: "clone",
  suspend: "suspend",
  pause: "pause",
  active: "active",
  create: "create",
  edit: "edit",
  publish: "publish",
  retire: "retire",
  cancel: "cancel",
  unSuspend: "unSuspend",
};

export const USER = {
  suspendUser: {
    user_account_status: 2,
  },
  unSuspendUser: {
    user_account_status: 1,
  },
  formType: {
    addForm: "AddForm",
    editForm: "EditForm",
  },
  fileName: "user_onboarding.csv",
};

export const catalogCsvFile = "catalog.csv";

export const TENANT = {
  pauseTenant: {
    subscription_status: 0,
  },
  activeTenant: {
    subscription_status: 1,
  },
};

export const FORMTYPE = {
  viewForm: "ViewForm",
  editForm: "EditForm",
  createForm: "CreateForm",
};

export const skuListType = {
  masterSkuList: "masterSkuList",
  catalogSkuList: "catalogSkuList",
  addSkuList: "addSkuList",
  fetchMasterList: "fetchMasterList",
};

export const pageSizeOptions = [10, 20, 30, 40];

export const Ten = 10;
export const Twenty = 20;
export const one = 1;
export const two = 2;
export const three = 3;

export const dateFormat = "DD.MM.YYYY";
export const dateFormat2 = "MM/DD/YYYY";

export const americanDateFormat = "YYYY-MM-DD";
export const vmDateFormat = "DD/MM/YYYY";

export const textDate = "DD MMM YYYY";

export const timeFormat = "HH:mm:ss";

export const dateTimeFormat = "D MMM YYYY, h:mm A";
export const dateTimeFormat2 = "YYYY-MM-DD H:mm";
export const dateTimeFormat3 = "MM/DD/YYYY hh:mm A";

export const secondTimeFormat = "HH:mm:ss A";
export const secondDateFormat = "D MMM YYYY";

export const thirdTimeFormat = "hh:mm:ss A";
export const fourthTimeFormat = "hh:mm";
export const fifthTimeFormat = "hh:mm A";
export const sixthTimeFormat = "HH:mm";
export const typeOfConstants = {
  number: "number",
};

export const permissionsList = [
  {
    label: "Create",
    value: "1",
    key: "create",
  },
  {
    label: "View",
    value: "2",
    key: "view",
  },
  {
    label: "Update",
    value: "3",
    key: "update",
  },
  {
    label: "Delete",
    value: "4",
    key: "delete",
  },
  {
    label: "Retrive",
    value: "5",
    key: "retrive",
  },
];

export const privateResourceProvider = "private_resource_provider";
export const publicResourceProvider = "public_resource_provider";
export const privateRProviderAddResource = "resourceProvider";
export const publicResProvider = "publicResourceProvider";
export const publicCreateTemplate = "publicCreateTemplate";
export const publicEditTemplate = "publicEditTemplate";
export const publicLab = "public";
export const privateLab = "private";
export const myLabsPrivate = "my_labs_private";
export const myLabsPublic = "my_labs_public";

export const templateStatus = {
  available: "",
  pooled: "NA",
  deleted: "2",
  retired: "5",
};

export const templateTabs = {
  available: "0",
  pooled: "1",
  deleted: "2",
  retired: "3",
};

export const osPlatform = ["Windows", "Linux"];

export const emptyList = {
  data: {
    data: {
      count: null,
      result: [],
    },
  },
};

export const statusOptions = [
  { label: "Published", value: 4 },
  { label: "Decommisioned", value: 6 },
];

export const cloudLabsStatusOptions = [
  { id: "active", value: "active", label: "Active" },
  { id: "failed_to_cleanup", value: "failed_to_cleanup", label: "Failed to Cleanup" },
  { id: "bill_failed", value: "bill_failed", label: "Bill Failed" },
  { id: "bill_overspilled", value: "bill_overspilled", label: "Bill Overspilled" },
];

export const CLOUD_LABS_STAT_CARDS = [
  { key: "active_labs", label: "Active Labs", color: "#52c41a" },
  { key: "failed_labs", label: "Cleanup Failed Labs", color: "#ff4d4f" },
  { key: "overutilized_labs", label: "Overutilized Labs", color: "#fa8c16" },
  { key: "billing_success", label: "Billing Fetch Success", color: "#52c41a" },
  { key: "billing_failure", label: "Billing Fetch Failure", color: "#ff4d4f" },
  { key: "manual_cleanup_needed", label: "Manual Cleanup Needed", color: "#722ed1" },
];

export const STATUS_TAG_MAP = {
  active: "success",
  failed_to_cleanup: "error",
  bill_failed: "error",
};

export const osFilterData = [
  {
    text: "Windows",
    value: 0,
  },
  {
    text: "Linux",
    value: 1,
  },
];

export const logStatus = [
  { label: "All", value: "" },
  { label: "Error", value: "error" },
  { label: "Warning", value: "warning" },
  { label: "Success", value: "info" },
];

export const vtEnabledData = [
  {
    text: "Enabled",
    value: "true",
  },
  {
    text: "Disabled",
    value: "false",
  },
];

export const toasterFlags = {
  SUCCESS: "success",
  WARN: "warning",
  INFO: "info",
  ERROR: "error",
};

export const catalogLabsList = {
  readMoreLimit: 40,
};

export const myLabsConstants = {
  DELETE: "DELETE",
  START: "START",
  STOP: "STOP",
  SUSPEND: "SUSPEND",
  RESET: "RESET",
  RESTARTGUEST: "RESTARTGUEST",
  SHUTDOWNGUEST: "SHUTDOWNGUEST",
  FORCEDELETE: "FORCEDELETE",
  EXTSNQUOTA: "Your Quota is exhausted. Please contact Admin.",
  SETQUOTA: "No Extension pack available, please contact your Tenant Admin",
  EXTSNSUCESS: "Your VM Extended Successfully.",
  Failure: "Failure",
};

export const myLabsEnum = {
  START: 1,
  STOP: 2,
  SHUTDOWNGUEST: 3,
  RESET: 4,
  RESTART_GUEST: 5,
  SUSPEND: 6,
  DELETE: 7,
  FORCE_DELETE: 8,
};

export const vmStateManageEnum = {
  RUNNING: 28,
  SUSPEND: 32,
  STOP: 30,
  PROVISION: 26
}

export const address = {
  country: "country",
  state: "state",
  city: "city",
  country_keyName: "country_name",
  state_KeyName: "state_name",
  city_keyName: "city_name",
};

export const quotaForm = {
  formType: {
    addForm: "AddForm",
    editForm: "EditForm",
  },
};

export const tenantNotificationForm = {
  formType: {
    addForm: "AddForm",
    editForm: "EditForm",
  },
};

export const pricingProfileData = [
  {
    label: "Fixed Cost Per VM",
    value: 1,
    key: 1,
  },
  {
    label: "Pay per use",
    value: 2,
    key: 2,
  },
  {
    label: "Fixed hours at company",
    value: 3,
    key: 3,
  },
  {
    label: "Fixed cost at company",
    value: 4,
    key: 4,
  },
];

export const billingCycleProfileData = [
  {
    label: "Weekly",
    value: 7,
    key: 7,
  },
  {
    label: "Monthly",
    value: 31,
    key: 31,
  },
  {
    label: "Yearly",
    value: 365,
    key: 365,
  },
  {
    label: "Quarterly",
    value: 90,
    key: 90,
  },
];

export const currencyProfileData = [
  {
    label: "INR",
    value: 0,
    key: 0,
  },
  {
    label: "USD",
    value: 1,
    key: 1,
  },
];
export const currencySymbols = {
  INR: "₹",
  USD: "$",
};
export const pricingProfileFormTypes = [
  [
    "profile_type",
    "billing_cycle",
    "is_onboard_fee",
    "onboard_fee",
    "currency",
    "end_date_agreement",
    "is_billing_visible_to_tenant_user",
  ],
  [
    "profile_type",
    "billing_cycle",
    "is_onboard_fee",
    "onboard_fee",
    "currency",
    "end_date_agreement",
    "is_billing_visible_to_tenant_user",
  ],
  [
    "profile_type",
    "billing_cycle",
    "no_of_hours",
    "end_date_agreement",
    "is_onboard_fee",
    "onboard_fee",
    "currency",
    "pay_per_user",
    "is_billing_visible_to_tenant_user",
  ],
  [
    "profile_type",
    "billing_cycle",
    "max_cost_allowed",
    "end_date_agreement",
    "pay_per_user",
    "is_onboard_fee",
    "onboard_fee",
    "currency",
    "is_billing_visible_to_tenant_user",
  ],
  [
    "profile_type",
    "billing_cycle",
    "is_onboard_fee",
    "onboard_fee",
    "currency",
    "is_billing_visible_to_tenant_user",
  ],
];

export const templateList = [
  {
    label: "Template1",
    value: "Template1",
  },
  {
    label: "Template2",
    value: "Template2",
  },
  {
    label: "Template3",
    value: "Template3",
  },
  {
    label: "Template4",
    value: "Template4",
  },
];

export const notificationManagementConstant = {
  notification: "Notification",
  users: "Users",
  myNotifications: "My Notifications",
  custom: "Custom",
  default: "Default",
  fileName: "Users",
  odlInactive: "ODL-INACTIVE",
  odlDeleted: "ODL-DELETE",
};

export const notificationTabs = {
  custom: "1",
  default: "2",
};

export const roleName = {
  superadmin: "superadmin",
  tenantUser: "tenantuser",
  csmadmin: "csmadmin",
  tenantadmin: "tenantadmin",
  labadmin: "labadmin",
  viewer: "viewer",
  accountmanager: "accountmanager",
  tenantuser: "tenantuser",
};

export const notificationform = {
  addForm: "addForm",
  editForm: "EditForm",
};

export const dataType = {
  object: "object",
};

export const requestStatus = {
  pending: 0,
  approved: 1,
  deleted: 2,
  declined: 3,
  submitted: 4,
};

export const requestType = {
  vmProvision: "VM-PROVISION",
  vmExtension: "VM-EXTENSION",
  vmReconfigure: "VM-RECONFIGURE",
};

export const uploadHtmlTemplateFieldNames = [
  "vm_decomission_warning_notification_templates",
  "vm_expiry_warning_notification_templates",
  "vm_expired_notification_template",
  "vm_unutilized_warning_notification_template",
  "resource_usage_summary_report_template",
  "daily_activities_report_template",
];

export const ONEKBINBYTES = 1024;
export const ONEMBINKB = 1024;

export const approvedDeclined = [
  { label: "Approve", value: 0 },
  { label: "Decline", value: 1 },
];

export const deploymentState = {
  1: "Creation in Progress",
  2: "Base Vm NotFound",
  3: "Cluster NotFound",
  4: "Data center NotFound",
  5: "DVS NotFound",
  6: "TenantPortGroup NotFound",
  7: "Datastore NotFound",
  8: "SnapShot NotFound",
  9: "Configure Param Success",
  10: "Cloning in Progress",
  11: "Cloning Failed",
  12: "Cloning Success",
  13: "ReConfigure in Progress",
  14: "ReConfigure Failed",
  15: "Reconfigure Success",
  16: "InitialBoot in Progress",
  17: "InitialBoot Success",
  18: "InitialBoot Failed",
  19: "Customization in Progress",
  20: "Customization Failed",
  21: "Customization Success",
  22: "Initial Suspend in Progress",
  23: "Initial Suspend Success",
  24: "Initial Suspend Failed",
  25: "Provisioning Failed",
  26: "Provisioning Success",
  27: "Power On in Progress",
  28: "Running",
  29: "Power Off in Progress",
  30: "Stopped",
  31: "Suspend in Progress",
  32: "Suspended",
  33: "Restarting",
  34: "Restarting GuestOS",
  35: "ShutDown GuestOS in Progress",
  36: "Deletion in Progress",
  37: "Deleted",
};

export const stageMessages = {
  1: "progress-stage",
  2: "error-stage",
  3: "error-stage",
  4: "error-stage",
  5: "error-stage",
  6: "error-stage",
  7: "error-stage",
  8: "error-stage",
  9: "success-stage",
  10: "progress-stage",
  11: "error-stage",
  12: "success-stage",
  13: "progress-stage",
  14: "error-stage",
  15: "success-stage",
  16: "progress-stage",
  17: "success-stage",
  18: "error-stage",
  19: "progress-stage",
  20: "error-stage",
  21: "success-stage",
  22: "progress-stage",
  23: "success-stage",
  24: "error-stage",
  25: "error-stage",
  26: "success-stage",
  27: "progress-stage",
  28: "progress-stage",
  29: "progress-stage",
  30: "progress-stage",
  31: "progress-stage",
};

export const deploymentStatus = {
  0: "In Progress",
  1: "Failed",
  2: "Success",
};

export const templateExport = {
  fileName: "TemplateExport.csv",
};

export const unlimitedColumnFieldsMap = new Map([
  ["is_cores_unlimited", "cores"],
  ["is_memory_unlimited", "memory"],
  ["is_storage_unlimited", "storage"],
  ["is_total_vm_unlimited", "total_vm_count"],
  ["is_monthly_quota_vms_unlimited", "monthly_quota_vms"],
  ["is_no_concurrent_connect_unlimited", "no_concurrent_connect"],
  ["is_max_vm_per_user_unlimited", "max_vm_per_user"],
  ["is_max_vm_auto_approve_per_user_unlimited", "max_vm_auto_approve_per_user"],
]);

export const TABLE_SCROLL_Y = "20rem";

export const websocketPaths = {
  vmStatus: "/v1/ws/vm",
  deploymentJobs: "/v1/ws/deployment-job",
  notifications: "/v1/ws/notifications",
  dashboard: "/v1/ws/dashboard",
  usageReport: "/v1/ws/usage-report",
  standAloneLabsVmStatus: "/v1/ws/cloud-lab",
};

export const iconTypeMap = [
  <CreateTemplate />,
  <Warning />,
  <Alert />,
  <Alert />,
  <Warning />,
];
export const dashboard_units = {
  cpu: "GHz",
  mem: "GiB",
};
export const dashboard_labels = {
  used: "Used",
  available: "Available",
  activeUsers: "Active Users Logged In",
  totalUsers: "Total Users",
  total: "Total",
};

export const usageTrendsRadios = {
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  yearly: "Yearly",
};

export const errorWentWrong = "Something Went Wrong";

export const idleTime = 6000000;

export const networkType = [
  { label: "DVS Network", value: 0, key: 0 },
  { label: "Standard Network", value: 1, key: 1 },
];

export const approvals = {
  vmApproval: "VM_APPROVAL",
  extnsApproval: "EXTENSION_APPROVAL",
  quotaExceed: "QUOTA_EXCEED",
  redirect: "Redirect",
};

export const generatedReportStatus = {
  1: "Initializing Report",
  2: "Creation In Progress",
  3: "Collecting Data",
  4: "Setting Up Data",
  5: "Finishing Report",
  6: "Download Available",
  7: "Data Not Found",
};

export const generatedWorkspaceBatchReportStatus = {
  0: "Started ",
  1: "Completed",
  2: "Failed",
  3: "Data Not Found",
};

export const FIVE_SECONDS = 5000;

export const customRuleCases = {
  lessThan: "lessThan",
  greaterThan: "greaterThan",
  maxTagLength: "maxTagLength",
  password: "password",
  greaterThanEqual: "greaterThanEqual",
};

export const vmFailureStates = [2, 3, 4, 5, 6, 7, 8, 11, 14, 18, 20, 24, 25];
export const vmInProgessAndInSuccessStatus = [
  1, 9, 10, 12, 13, 15, 16, 17, 19, 21, 22, 23,
];
export const vmInSuccessStatus = [9, 12, 15, 17, 21, 23, 26];
export const vmStatesAfterStart = [26, 28, 30, 32, 33];
export const vmStatesExtend = [26, 27, 28, 30, 32, 33];
export const vmOperationSuccessStates = [28, 30, 32, 33, 34];
export const dashboardVmOperationStates = [27, 28, 29, 30, 31, 32];

export const rootSubmenuKeys = [
  "resource_provider",
  "tenants",
  "notification_templates",
  "settings",
];
export const pleaseTryAgainAfterSomeTimeMsg = "Please Try after some time.";

export const authTypes = {
  localUser: "LocalUser",
  azuerAD: "AAD",
  azuerB2C: "AADB2C",
  SAML: "SSO",
};

export const workspaceTabs = {
  workspaceDashboard: 0,
  usageReport: 1,
};

export const labTypeOptions = [
  { key: 0, label: "Persistent", value: 0 },
  { key: 1, label: "Non Persistent", value: 1 },
];
export const workspaceStatus = {
  0: "unpublished",
  1: "published",
  2: "onHold",
  3: "resumed",
};

export const workspaceAction = {
  0: "publish",
  1: "hold",
  2: "resume",
  3: "hold",
};

export const workspaceActionData = {
  0: 1,
  1: 2,
  2: 3,
  3: 2,
};

export const viewWorkspaceTabs = {
  workspaceDetails: 0,
  resources: 1,
  users: 2,
};

export const workspaceLabType = {
  0: "Persistant",
  1: "Non persistant",
};

export const scheduleOptions = [
  { key: 0, value: 0, label: "Date Range" },
  { key: 1, value: 1, label: "Custom Recurrence" },
  { key: 2, value: 2, label: "Duration" },
];

export const endsOptions = [
  {
    key: 0,
    value: 0,
    label: "Never",
  },
  { key: 1, value: 1, label: "On" },
  { key: 2, value: 2, label: "After" },
];

export const monthly_type_options = [
  {
    key: 0,
    label: "Same date Every Month",
    value: 0,
  },
  {
    key: 1,
    label: "Same weekday Every Month",
    value: 1,
  },
];

export const repeatEvery = [
  {
    key: 0,
    label: "Day",
    value: 0,
  },
  {
    key: 1,
    label: "Week",
    value: 1,
  },
  {
    key: 2,
    label: "Month",
    value: 2,
  },
  {
    key: 3,
    label: "Year",
    val: 3,
  },
];

export const days_arr = [
  { id: 7, label: "S", active: false },
  { id: 1, label: "M", active: false },
  { id: 2, label: "T", active: false },
  { id: 3, label: "W", active: false },
  { id: 4, label: "T", active: false },
  { id: 5, label: "F", active: false },
  { id: 6, label: "S", active: false },
];

export const auth_schedule_options = [
  { key: 0, value: 0, label: "Bulk Upload via csv" },
  { key: 1, value: 1, label: "Manual Registration" },
  { key: 2, value: 2, label: "Create Invitation Link" },
  { key: 3, value: 3, label: "User Upload" },
];

export const auth_config_options = [
  { key: 0, value: 0, label: "SSO" },
  { key: 1, value: 1, label: "AAD" },
  { key: 2, value: 2, label: "AADB2C" },
  { key: 3, value: 3, label: "Local User" },
];

export const manage_users = [
  { key: 0, value: 0, label: "Assign User" },
  { key: 1, value: 1, label: "Bulk Upload" },
];

export const workspace_manage_users = [
  { key: 0, value: 0, label: "Assign User" },
  { key: 1, value: 1, label: "Bulk Upload" },
  { key: 2, value: 2, label: "New Users" },
];

export const toEnableDelete = [
  2, 3, 4, 5, 6, 7, 8, 11, 14, 18, 20, 24, 25, 26, 30, 32, 36,
];
export const toEnableReprovision = [
  2, 3, 4, 5, 6, 7, 8, 11, 14, 18, 20, 24, 25,
];

export const workspaceResourcesStatus = {
  0: "Created",
  1: "Allocated",
  2: "Deleted",
  3: "Unallocated",
  4: "Extended",
  5: "Provision_Failed",
};

export const timeZero = "00:00";
export const timeZeroUtc = "18:30";
export const tenantServices = [
  { key: 0, value: 0, label: "Allow Portal Login" },
  { key: 1, value: 1, label: "Allow Workspace Login" },
];

export const tenantServicesMap = {
  portalLogin: 0,
  workspaceLogin: 1,
  both: 2,
};
export const SENT = "Sent";
export const REJECTED = "Rejected";
export const FAILED = "Failed";

const role = getUserRole();
export const myLabsOpsConstants = {
  toEnableLabStart: [26, 27, 29, 30, 32],
  toEnableSuspend: role === roleName.tenantuser ? [28] : [28, 31],
  toEnableStop: role === roleName.tenantuser ? [28, 32] : [28, 32, 29],
  toEnablePowerOn: [26, 27, 30, 32],
  toEnableConnect: [30, 28],
  toEnableReset: [28, 33],
  toEnableShutdownGuestOs: [28, 35],
  toEnableRestartGuestOs: [28, 34],
};

export const V1 = "v1";
export const DOC = "doc";

export const helpItems = [
  {
    id: 0,
    text: "Application Help",
  },
  {
    id: 1,
    text: "API Help Document",
  },
];

export const adminCatalogType = {
  public: "public",
  private: "private",
};

export const labBatchTabs = {
  labs: "Stand alone Labs",
  batch: "Batch",
  linkTenants: "Link Tenants",
  workSpaceBatch: "Workspace Batch",
  workspaceBatchReports: "Workspace Batch Reports",
};

export const CreditBasedLabTabs = {
  accessInformation: 0,
  usageDetails: 1,
  extensionDetails: 2,
};

export const usageDetailsDurationTabs = {
  previousMonth: 0,
  currentMonth: 1,
};

export const customCloudProviderHeader = () => {
  let authToken = "";
  const wsAmuthType = localStorageHelper.get("wsm_auth_type");
  if (wsAmuthType) {
    //Auh token based on auth type
    authToken =
      wsAmuthType === authTypes.azuerAD
        ? localStorageHelper.get("wsmAuthToken")
        : localStorageHelper.get("wsmAccessToken");
  } else if (localStorageHelper.get("auth_type")) {
    //Auh token based on auth type
    authToken =
      localStorageHelper.get("auth_type") === authTypes.azuerAD
        ? localStorageHelper.get("authToken")
        : localStorageHelper.get("accessToken");
  }
  const authType = wsAmuthType || localStorageHelper.get("auth_type");
  return {
    headers: {
      Accept: "application/json",
      tenant:
        wsAmuthType === authTypes.azuerAD || wsAmuthType === authTypes.localUser
          ? localStorageHelper.get("wsmTenantId")
          : authType === authTypes.SAML
            ? localStorageHelper.get("localTenantId")
            : localStorageHelper.get("tenantId"),
      Authorization: authToken,
      role: localStorageHelper.get("role"),
      authType,
    },
  };
};

export const cloudLabType = { standalone: 0, batch: 1 };
export const cloudExtensionType = { lab: 0, batch: 1 };

export const standaloneLabStatus = {
  0: "Sent for Provisioning",
  1: "Fetching Config",
  2: "Account Provisioning",
  3: "Account Configuring",
  4: "Success",
  5: "Failed",
};

export const cloudLabStatus = {
  0: "Lab Sent For Provisioning",
  1: "Fetch Config In Progress",
  2: "Account Provisioning In Progress",
  3: "Account Config In Progress",
  4: "Success",
  5: "Failed",
  6: "Expired",
  7: "Lab Re-Triggered",
  8: "Deleted",
};

export const CLOUD_FILTERS = {
  0: "aws",
  1: "azure",
  2: "gcp",
};

export const quotaResetforUserData = [
  {
    label: "Weekly",
    value: 7,
    key: 7,
  },
  {
    label: "Monthly",
    value: 31,
    key: 31,
  },
  {
    label: "Yearly",
    value: 365,
    key: 365,
  },
  {
    label: "Quarterly",
    value: 90,
    key: 90,
  },
];

export const quotaResetforUserEnum = {
  7: "Week",
  31: "Month",
  365: "Year",
  90: "Quarter",
};

export const capacityOptions = [
  { key: 0, value: 0, label: "All" },
  { key: 1, value: 1, label: "Workspace" },
];

export const resourcesOptions = [
  { key: 0, value: 0, label: "CPU" },
  { key: 1, value: 1, label: "Memory" },
];

export const viewsOptions = [
  { value: 0, label: "Machines" },
  { value: 1, label: "Sessions" },
  { value: 2, label: "Connections" },
  { value: 3, label: "Application Instances" },
];

export const reportTabs = {
  faliure: 0,
  sessions: 1,
  capacityManagement: 2,
  machineUsage: 3,
  reportUtilization: 4,
};
export const catalogLabs = [
  { label: "All", value: "" },
  { label: "Stand Alone Lab", value: "standalone" },
  { label: "Guided Lab", value: "guided" },
];
export const b2cPrivateLabs = [
  { label: "Stand Alone Lab", value: "standalone" },
  { label: "Guided Lab", value: "guided" },
];

export const errorMessage = "An error has occurred. Please try again";

export const instanceSizeRegEx = /[a-zA-Z]+\d\.[a-zA-Z0-9]+\s\d+MB+,\s\d+VCPU/;
export const alphaNumericRegEx = /\w*[a-zA-Z]+\w*/;

export const requestTicketStatusEnum = {
  pending: 0,
  approved: 1,
  decline: 2,
};

export const approvedDeclinedRequestLab = [
  { label: "Approve", value: 1 },
  { label: "Decline", value: 2 },
];

export const requestLabStatus = 4;

export const templateTypes = [
  {
    key: 0,
    value: 0,
    label: "Guided Lab",
    underText: "Follow the steps and instructions to complete the lab",
  },
  {
    key: 1,
    value: 1,
    label: "Standalone",
    underText: "Create a regular template with information using param specs  ",
  },
];

export const accountTabs = {
  cleaningJobs: 0,
  AwsUsage: 1,
};

export const AzureVMState = {
  OBJ_CREATED: 0,
  PROVISION_STARTED: 1,
  PROVISION_COMPLETED: 2,
  PROVISION_FAILED: 4,
  VM_SHUTDOWN: 5,
  VM_ACTIVE: 6,
  VM_DELETED: 7,
};

export const AzureVMStateLabel = {
  [AzureVMState.OBJ_CREATED]: "Object Created",
  [AzureVMState.PROVISION_STARTED]: "Provision Started",
  [AzureVMState.PROVISION_COMPLETED]: "Provision Completed",
  [AzureVMState.PROVISION_FAILED]: "Provision Failed",
  [AzureVMState.VM_SHUTDOWN]: "VM Shutdown",
  [AzureVMState.VM_ACTIVE]: "VM Active",
  [AzureVMState.VM_DELETED]: "VM Deleted",
};
